import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import P from './P';
import H2 from './H2';
import Block from './Block';
import Grid from './Grid';
import Cell from './Cell';
import Image from './Image';

const PageLogosRow = ({ content }) => (
  <Block backgroundColor="grayLight">
    <Grid>
      {content.primary.title1 && content.primary.title1.text && (
        <Cell size={1} position="relative" pt="baseUnit">
          <H2
            px="baseUnit"
            mb="baseUnit"
            textAlign={content.primary.title_alignment}
          >
            {content.primary.title1.text}
          </H2>
        </Cell>
      )}

      <Cell size={1}>
        <Block
          display="flex"
          alignItems="center"
          justifyContent="space-around"
          flexWrap="wrap"
        >
          {content.items.map((item) => {
            const { logo } = item;

            return logo.localFile?.childImageSharp?.gatsbyImageData ? (
              <Block key={`logo-item-${logo.localFile?.id}`} p="baseDown1">
                <Image content={logo} />
              </Block>
            ) : (
              <Block backgroundColor="orange" p="baseDown1">
                <P mb="0" fontSize="baseDown1" isBold>
                  Logo in incrrect file format
                </P>
                <P mb="0" fontSize="baseDown1" isBold>
                  (gif/svg not supported)
                </P>
              </Block>
            );
          })}
        </Block>
      </Cell>
    </Grid>
  </Block>
);

PageLogosRow.propTypes = {
  content: PropTypes.shape({
    primary: PropTypes.shape({
      title1: PropTypes.shape({
        text: PropTypes.string.isRequired,
      }),
      title_alignment: PropTypes.string,
    }).isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
};

export default PageLogosRow;

export const query = graphql`
  fragment LogosRowFragment on PrismicPageDataBodyLogosRow {
    id
    slice_type
    primary {
      title_alignment
      title1 {
        text
      }
    }
    items {
      logo {
        alt
        localFile {
          id
          childImageSharp {
            gatsbyImageData(
              layout: FIXED
              width: 100
              transformOptions: { grayscale: true }
            )
          }
        }
      }
    }
  }
`;
